import { render, staticRenderFns } from "./user-activity-card.vue?vue&type=template&id=b9ecc0f0&scoped=true&"
import script from "./user-activity-card.vue?vue&type=script&lang=ts&"
export * from "./user-activity-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ecc0f0",
  null
  
)

export default component.exports